export const COLOR_TRASH = "#888888";
// export const COLOR_COMMON = "#ffffff";
export const COLOR_COMMON = "#000000";
export const COLOR_UNCOMMON = '#00cc00';
export const COLOR_RARE = '#2681fe';
export const COLOR_EPIC = '#b049ff';
export const COLOR_RELIC = '#ff9900';
export const COLOR_TRANSCENDENT = '#cf1313';
export const COLOR_ETERNAL = '#6bd3f7';
export const COLOR_HEIRLOOM = '#ffaaff';
export const COLOR_QUEST_ITEM = '#fff600';

const colorMap = new Map([
    ['Trash', COLOR_TRASH],
    ['Common', COLOR_COMMON],
    ['Uncommon', COLOR_UNCOMMON],
    ['Rare', COLOR_RARE],
    ['Epic', COLOR_EPIC],
    ['Relic', COLOR_RELIC],
    ['Transcendent', COLOR_TRANSCENDENT],
    ['Eternal', COLOR_ETERNAL],
    ['Heirloom', COLOR_HEIRLOOM],
    ['Quest Item', COLOR_QUEST_ITEM],
]);

export const getRarityColor = (rarity) => {
    return colorMap.has(rarity) ? colorMap.get(rarity) : COLOR_COMMON;
}


// WEBPACK FOOTER //
// ./src/common/RarirtyColorFactory.js